import { BaseEnum } from "./baseEnum"

const listBenefitEntryModeTypeEnum: Array<BenefitEntryModeType> = [];

export class BenefitEntryModeType extends BaseEnum {
  static SINGLE_SELECTION_FOR_TYPE = new BenefitEntryModeType(1, 'SingleSelectionForType', 'Seleção única para tipo', 'info');
  static MULTIPLE_SELECTION_FOR_TYPE = new BenefitEntryModeType(2, 'MultipleSelectionForType', 'Seleção múltipla para tipo', 'warning');

  constructor(public id: number, public value: string, public label: string, public className: string) {
    super(id, value, label, className)
    listBenefitEntryModeTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listBenefitEntryModeTypeEnum;
  }
}
